import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=1f6b2bf0&"
import script from "./UsersEdit.vue?vue&type=script&lang=ts&"
export * from "./UsersEdit.vue?vue&type=script&lang=ts&"
import style0 from "./UsersEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports